import { R } from '@core/utils/r';
import { CourseInboxResponse, CourseInboxId, CourseInboxSearchParams, UnreadInboxMessages } from '@business/entities/course_inbox';
import { Endpoint } from '@business/api/endpoint';
import { VeryCompactCourseResponse } from '@business/entities/course';

export function fetchCourseInboxs(params?: CourseInboxSearchParams) {
  return Endpoint.get<CourseInboxResponse[]>(`@gc/instructor-inbox`, { params: R.objectCompact(params) });
}

export function createCourseInbox(data: Partial<CourseInboxResponse>) {
  return Endpoint.post<CourseInboxResponse>(`@gc/instructor-inbox`, { data });
}

export function updateCourseInbox(id: CourseInboxId, data: Partial<CourseInboxResponse>) {
  return Endpoint.patch<CourseInboxResponse>(`@gc/instructor-inbox/${id}`, { data });
}

export function deleteCourseInbox(id: CourseInboxId) {
  return Endpoint.delete<void>(`@gc/instructor-inbox/${id}`);
}

export function fetchCourseInbox(id: CourseInboxId) {
  return Endpoint.get<CourseInboxResponse>(`@gc/instructor-inbox/instructor-inbox/${id}`);
}

export function getUnreadMessages() {
  return Endpoint.get<UnreadInboxMessages>(`@gc/instructor-inbox/unread`);
}

export function getCourses() {
  return Endpoint.get<VeryCompactCourseResponse[]>(`@gc/instructor-inbox/courses`);
}
